<template lang="pug">
  v-container
    v-layout(align-center, justify-center, row, fill-height)
      v-card(width='800px', height='500px')
        v-layout(v-if='signUpSuccess', align-center, fill-height)
          v-layout(align-center, justify-center, column, fill-height)
            h2.mb-2 {{ $t('pageHeader.verifyYourEmail') }}
            p {{ $t('subTitle.verifyMessage') }}
            v-btn(@click='resend') Resend Email
            v-btn(to='/login') {{ $t('buttons.alreadyVerified') }}
        v-layout.pa-4(column, fill-height, v-else)
          v-layout(row, fill-height)
            v-flex(xs12, md6, fill-height)
              v-layout(column, fill-height)
                // logo
                v-flex(shrink)
                  img(height='35px', src='../../assets/logo.png')
                // header
                v-flex.mt-2(shrink)
                  h1 {{ $t('pageHeader.createYourCellSmartAccount')}}
                // user info
                v-layout(wrap, shrink)
                  v-flex.pa-1(xs6)
                    v-text-field(:error-messages='firstNameErrors', :label="$t('labels.firstName')", v-model='user.firstName')
                  v-flex.pa-1(xs6)
                    v-text-field(:label="$t('labels.lastName')", :error-messages='lastNameErrors', v-model='user.lastName')
                v-flex(shrink)
                  v-text-field.pa-1(:label="$t('labels.companyName')", :error-messages='companyNameErrors', v-model='user.companyName')
                v-flex(shrink)
                  v-text-field.pa-1(:label="$t('labels.email')", :error-messages='emailErrors', v-model='user.email')
                v-layout(row, shrink)
                  v-flex.pa-1(xs6)
                    v-text-field(:label="$t('labels.password')", :error-messages='passwordErrors', v-model='user.password', type='password')
                  v-flex.pa-1(xs6)
                    v-text-field(:label="$t('labels.confirmPassword')", :error-messages='confirmPasswordErrors', v-model='user.confirmPassword', type='password', v-on:keyup.enter='submit')
                v-spacer
                // option to sign in and sign up
                // terms
            v-layout(hidden-sm-and-down, md6, align-center)
              img(width='100%', src='../../assets/images/virtual-pos.png')
          v-layout(row, justify-space-between, shrink)
            v-btn(flat, to='/login') {{ $t('buttons.signIn') }}
            v-btn(color='orange', dark, @click='submit') {{ $t('buttons.next') }}

</template>
<script>
import signUpService from './service.js'

const { validationMixin } = require('vuelidate')
const {
  required,
  minLength,
  email,
  sameAs,
} = require('vuelidate/lib/validators')

export default {
  name: 'signUp',
  created() {
    if (this.$route.query) {
      this.user.ReferralCode = this.$route.query.referralCode
      this.user.email = this.$route.query.email
    }
  },
  data() {
    return {
      user: {
        firstName: null,
        lastName: null,
        companyName:null,
        email: null,
        password: null,
        acceptedTerms: false,
        ReferralCode: null,
        confirmPassword: null,
      },
      signUpSuccess: false,
    }
  },
  methods: {
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'error',
          title: this.$t('toastMessage.text.invalidFields')
        })
      } else {
        signUpService.submit(this.user)
          .then((response) => {
            console.log(response)
            this.signUpSuccess = true
          })
          .catch((error) => {
            console.log('test', error)
            this.$toasted.error(error.data.message, {
              position: 'top-right',
              showHideTransition: 'slide',
              duration: 3500,
            })
          })
      }
    },
    resend() {
      console.log(this.email)
      signUpService.resendVerifyEmail({ email: this.user.email })
        .then((response) => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })

          Toast.fire({
            type: 'success',
            title: `Resent Email to ${this.user.email}`
          })
        })
        .catch((error) => {
          this.$Progress.finish()
          this.isLoading = false
          this.error = true
          this.errorMessage = error.data.message
        })
    },
  },
  computed: {
    firstNameErrors() {
      const errors = []
      if (!this.$v.user.firstName.$dirty) return errors
      if (!this.$v.user.firstName.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.user.firstName.minLength) errors.push(this.$t('validations.fieldMustbeatLeast2ChrLong'))
      return errors
    },
    companyNameErrors() {
      const errors = []
      if (!this.$v.user.companyName.$dirty) return errors
      if (!this.$v.user.companyName.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    lastNameErrors() {
      const errors = []
      if (!this.$v.user.lastName.$dirty) return errors
      if (!this.$v.user.lastName.minLength) errors.push(this.$t('validations.fieldMustbeatLeast2ChrLong'))
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.user.email.$dirty) return errors
      if (!this.$v.user.email.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.user.email.email) errors.push(this.$t('validations.emailIsNotValid'))
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.user.password.$dirty) return errors
      if (!this.$v.user.password.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.user.password.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    confirmPasswordErrors() {
      const errors = []
      if (!this.$v.user.confirmPassword.$dirty) return errors
      if (!this.$v.user.confirmPassword.sameAsPassword) errors.push(this.$t('validations.passwordDoesNotMatch'))
      return errors
    },
  },
  mixins: [validationMixin],
  validations: {
    user: {
      firstName: {
        required,
        minLength: minLength(2),
      },
      lastName: {
        minLength: minLength(1),
      },
      companyName: {
        required,
        minLength: minLength(4),
      },
      email: {
        email,
        required,
      },
      password: {
        required,
        minLength: minLength(4),
      },
      confirmPassword: {
        sameAsPassword: sameAs('password'),
      },
    },
  },
}
</script>
<style lang="scss" scoped>
h1 {
    font-size: 22px;
    font-weight: 400;
    line-height: 32px;
    margin: 0;
}
</style>
